module.exports = __webpack_public_path__ + "static/fonts/iconfont.51dd82a.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/iconfonts/iconfont.ttf?t=1592806397367
// module id = aKVo
// module chunks = 71